export const storedData = [
  {
    name: "John Smith",
    address: [-1.9057193, 52.4845404],
    treats: {
      candy: false,
      chocolate: false,
      toys: false,
    },
    allergyInfo: "Allergy Cautious",
    hoursParticipation: {
      "4pm-6pm": false,
      "6pm-8pm": false,
      "8pm-10pm": false,
    },
    decorations: {
      yes: false,
      no: false,
    },
    notes: "",
    img: "/media/house_dummy.jpg",
  },
  {
    name: "Jack Skellington",
    address: [-1.9070709, 52.48482],
    treats: {
      candy: false,
      chocolate: true,
      toys: false,
    },
    allergyInfo: "Allergy Cautious",
    hoursParticipation: {
      "4pm-6pm": true,
      "6pm-8pm": true,
      "8pm-10pm": false,
    },
    decorations: {
      yes: false,
      no: false,
    },
    notes: "Please be spoopy",
    img: "/media/house_dummy.jpg",
  },
  {
    name: "Winnifred Sanderson",
    address: [-1.90474, 52.48492],
    treats: {
      candy: true,
      chocolate: false,
      toys: false,
    },
    allergyInfo: "Individually Wrapped",
    hoursParticipation: {
      "4pm-6pm": false,
      "6pm-8pm": true,
      "8pm-10pm": false,
    },
    decorations: {
      yes: false,
      no: false,
    },
    notes: "Please be spoopy",
    img: "/media/house_dummy.jpg",
  },
  {
    name: "Freddie Boo-ger",

    address: [-1.9058387, 52.4855057],
    treats: {
      candy: true,
      chocolate: false,
      toys: false,
    },
    allergyInfo: "Individually Wrapped",
    hoursParticipation: {
      "4pm-6pm": false,
      "6pm-8pm": true,
      "8pm-10pm": false,
    },
    decorations: {
      yes: false,
      no: false,
    },
    notes: "Please be spoopy",
    img: "/src/media/house_dummy.jpg",
  },
  {
    name: "Jane Doe",
    address: [-1.9027193, 52.4835404],
    treats: {
      candy: true,
      chocolate: false,
      toys: false
    },
    allergyInfo: "Peanut-Free",
    hoursParticipation: {
      "4pm-6pm": true,
      "6pm-8pm": false,
      "8pm-10pm": false
    },
    decorations: {
      yes: true,
      no: false
    },
    notes: "",
    img: "/src/media/house_dummy.jpg"
  },
  {
    name: "Tom White",
    address: [-1.9007193, 52.4865404],
    treats: {
      candy: false,
      chocolate: true,
      toys: false
    },
    allergyInfo: "Allergy Cautious",
    hoursParticipation: {
      "4pm-6pm": false,
      "6pm-8pm": true,
      "8pm-10pm": false
    },
    decorations: {
      yes: false,
      no: true
    },
    notes: "",
    img: "/src/media/house_dummy.jpg"
  },
  {
    name: "Alice Brown",
    address: [-1.9051193, 52.4850404],
    treats: {
      candy: true,
      chocolate: true,
      toys: false
    },
    allergyInfo: "Gluten-Free",
    hoursParticipation: {
      "4pm-6pm": false,
      "6pm-8pm": true,
      "8pm-10pm": true
    },
    decorations: {
      yes: true,
      no: false
    },
    notes: "Decorations include a spooky garden",
    img: "/src/media/house_dummy.jpg"
  },
  {
    name: "Chris Green",
    address: [-1.9047193, 52.4825404],
    treats: {
      candy: true,
      chocolate: false,
      toys: true
    },
    allergyInfo: "Nut-Free",
    hoursParticipation: {
      "4pm-6pm": true,
      "6pm-8pm": false,
      "8pm-10pm": true
    },
    decorations: {
      yes: false,
      no: true
    },
    notes: "",
    img: "/src/media/house_dummy.jpg"
  },
  {
    name: "Emily Black",
    address: [-1.9067193, 52.4840404],
    treats: {
      candy: false,
      chocolate: true,
      toys: true
    },
    allergyInfo: "Allergy Cautious",
    hoursParticipation: {
      "4pm-6pm": false,
      "6pm-8pm": false,
      "8pm-10pm": true
    },
    decorations: {
      yes: true,
      no: false
    },
    notes: "",
    img: "/src/media/house_dummy.jpg"
  },
  {
    name: "David Blue",
    address: [-1.9077193, 52.4855404],
    treats: {
      candy: true,
      chocolate: true,
      toys: false
    },
    allergyInfo: "Dairy-Free",
    hoursParticipation: {
      "4pm-6pm": true,
      "6pm-8pm": true,
      "8pm-10pm": false
    },
    decorations: {
      yes: false,
      no: true
    },
    notes: "",
    img: "/src/media/house_dummy.jpg"
  },
  {
    name: "Sophia Gray",
    address: [-1.9027193, 52.4875404],
    treats: {
      candy: true,
      chocolate: false,
      toys: true
    },
    allergyInfo: "Gluten-Free",
    hoursParticipation: {
      "4pm-6pm": false,
      "6pm-8pm": true,
      "8pm-10pm": true
    },
    decorations: {
      yes: true,
      no: false
    },
    notes: "",
    img: "/src/media/house_dummy.jpg"
  },
  {
    name: "Liam Silver",
    address: [-1.9037193, 52.4885404],
    treats: {
      candy: false,
      chocolate: true,
      toys: true
    },
    allergyInfo: "Peanut-Free",
    hoursParticipation: {
      "4pm-6pm": true,
      "6pm-8pm": false,
      "8pm-10pm": true
    },
    decorations: {
      yes: false,
      no: true
    },
    notes: "Extra decorations this year!",
    img: "/src/media/house_dummy.jpg"
  },
  {
    name: "Olivia Pink",
    address: [-1.9059193, 52.4895404],
    treats: {
      candy: true,
      chocolate: true,
      toys: false
    },
    allergyInfo: "Allergy Cautious",
    hoursParticipation: {
      "4pm-6pm": false,
      "6pm-8pm": true,
      "8pm-10pm": false
    },
    decorations: {
      yes: true,
      no: false
    },
    notes: "",
    img: "/src/media/house_dummy.jpg"
  },
  {
    name: "Mason Violet",
    address: [-1.9041193, 52.4805404],
    treats: {
      candy: true,
      chocolate: false,
      toys: true
    },
    allergyInfo: "Dairy-Free",
    hoursParticipation: {
      "4pm-6pm": false,
      "6pm-8pm": false,
      "8pm-10pm": true
    },
    decorations: {
      yes: false,
      no: true
    },
    notes: "",
    img: "/src/media/house_dummy.jpg"
  },
  {
    name: "Elijah Orange",
    address: [-1.9097193, 52.4835404],
    treats: {
      candy: true,
      chocolate: false,
      toys: false
    },
    allergyInfo: "Allergy Cautious",
    hoursParticipation: {
      "4pm-6pm": true,
      "6pm-8pm": false,
      "8pm-10pm": true
    },
    decorations: {
      yes: true,
      no: false
    },
    notes: "",
    img: "/src/media/house_dummy.jpg"
  },
  {
    name: "Noah Indigo",
    address: [-1.9035193, 52.4825404],
    treats: {
      candy: false,
      chocolate: true,
      toys: true
    },
    allergyInfo: "Nut-Free",
    hoursParticipation: {
      "4pm-6pm": false,
      "6pm-8pm": true,
      "8pm-10pm": true
    },
    decorations: {
      yes: false,
      no: true
    },
    notes: "Lots of spooky lights!",
    img: "/src/media/house_dummy.jpg"
  },
  {
    name: "Harper Red",
    address: [-1.9017193, 52.4860404],
    treats: {
      candy: true,
      chocolate: false,
      toys: false
    },
    allergyInfo: "Gluten-Free",
    hoursParticipation: {
      "4pm-6pm": true,
      "6pm-8pm": true,
      "8pm-10pm": false
    },
    decorations: {
      yes: true,
      no: false
    },
    notes: "",
    img: "/src/media/house_dummy.jpg"
  },
  {
    name: "James White",
    address: [-1.9087193, 52.4845404],
    treats: {
      candy: true,
      chocolate: true,
      toys: true
    },
    allergyInfo: "Peanut-Free",
    hoursParticipation: {
      "4pm-6pm": false,
      "6pm-8pm": true,
      "8pm-10pm": true
    },
    decorations: {
      yes: false,
      no: true
    },
    notes: "Family-friendly decorations",
    img: "/src/media/house_dummy.jpg"
  },
  {
    name: "Amelia Purple",
    address: [-1.9077193, 52.4870404],
    treats: {
      candy: false,
      chocolate: true,
      toys: true
    },
    allergyInfo: "Dairy-Free",
    hoursParticipation: {
      "4pm-6pm": true,
      "6pm-8pm": false,
      "8pm-10pm": true
    },
    decorations: {
      yes: true,
      no: false
    },
    notes: "Glow-in-the-dark decorations",
    img: "/src/media/house_dummy.jpg"
  },
  {
    name: "Jack Yellow",
    address: [-1.9053193, 52.4855404],
    treats: {
      candy: true,
      chocolate: false,
      toys: true
    },
    allergyInfo: "Allergy Cautious",
    hoursParticipation: {
      "4pm-6pm": false,
      "6pm-8pm": true,
      "8pm-10pm": false
    },
    decorations: {
      yes: false,
      no: true
    },
    notes: "",
    img: "/src/media/house_dummy.jpg"
  },
  {
    name: "Mia Cyan",
    address: [-1.9007193, 52.4885404],
    treats: {
      candy: true,
      chocolate: false,
      toys: true
    },
    allergyInfo: "Gluten-Free",
    hoursParticipation: {
      "4pm-6pm": false,
      "6pm-8pm": true,
      "8pm-10pm": true
    },
    decorations: {
      yes: true,
      no: false
    },
    notes: "",
    img: "/src/media/house_dummy.jpg"
  },
  {
    name: "Henry Magenta",
    address: [-1.9027193, 52.4840404],
    treats: {
      candy: true,
      chocolate: true,
      toys: true
    },
    allergyInfo: "Nut-Free",
    hoursParticipation: {
      "4pm-6pm": true,
      "6pm-8pm": true,
      "8pm-10pm": false
    },
    decorations: {
      yes: true,
      no: false
    },
    notes: "",
    img: "/src/media/house_dummy.jpg"
  }
  
];
